export default "__VITE_ASSET__DZwLprU9__"